import Vue from 'vue'
import Router from 'vue-router'
import { canAccessFrontRoute, readRuleList, resolveDefaultFrontRoute } from '@/utils/front-rules'
import Login from '@/pages/login.vue'
import CollLogin from '@/pages/collLogin.vue'
import CollEdit from '@/pages/collEdit.vue'
import Register from '@/pages/register.vue'
import TypeList from '@/pages/typeList.vue'
import GoodList from '@/pages/goodList.vue'
import GoodDetail from '@/pages/goodDetail.vue'
import Customer from '@/pages/customer.vue'
import Quotation from '@/pages/quotation.vue'
import Offer from '@/pages/offer.vue'
import OfferDetail from '@/pages/offerDetail.vue'
import OfferEdit from '@/pages/offerEdit.vue'
import Delivery from '@/pages/delivery.vue'
import DeliveryDetail from '@/pages/deliveryDetail.vue'
import Factory from '@/pages/factory.vue'
import FactoryDetail from '@/pages/factoryDetail.vue'
import Center from '@/pages/center.vue'
import PassSet from '@/pages/passSet.vue'
import Print from '@/pages/print.vue'
import CuttingPrint from '@/pages/cuttingPrint.vue'
import OrderStats from '@/pages/orderStats.vue'
import ProductManage from '@/pages/productManage.vue'
import AuthManage from '@/pages/authManage.vue'
import MemberManage from '@/pages/memberManage.vue'
import SettingsManage from '@/pages/settingsManage.vue'
import QuoteManage from '@/pages/quoteManage.vue'

Router.prototype.goBack = function() {
	this.isBack = true;
	window.history.go(-1);
};
Vue.use(Router)

let router = new Router({
	mode: 'history',
	base: '/',
	routes: [{
			path: '/',
			name: 'Login',
			component: Login,
			meta: {
				title: '登录'
			}
		},
		{
			path: '/register',
			name: 'Register',
			component: Register,
			meta: {
				title: '注册'
			}
		},
		{
			path: '/typeList',
			name: 'TypeList',
			component: TypeList,
			meta: {
				title: '分类列表'
			}
		},
		{
			path: '/goodList',
			name: 'GoodList',
			component: GoodList,
			meta: {
				title: '产品列表',
				keepAlive: !0
			}
		},
		{
			path: '/goodDetail',
			name: 'GoodDetail',
			component: GoodDetail,
			meta: {
				title: '产品详情'
			}
		},
		{
			path: '/customer',
			name: 'Customer',
			component: Customer,
			meta: {
				title: '客户信息'
			}
		},
		{
			path: '/quotation',
			name: 'Quotation',
			component: Quotation,
			meta: {
				title: '创建报价'
			}
		},
		{
			path: '/offer',
			name: 'Offer',
			component: Offer,
			meta: {
				title: '我的报价',
				keepAlive: !0
			}
		},
		{
			path: '/offerDetail',
			name: 'OfferDetail',
			component: OfferDetail,
			meta: {
				title: '报价单详情'
			}
		},
		{
			path: '/offerEdit',
			name: 'OfferEdit',
			component: OfferEdit,
			meta: {
				title: '报价单编辑'
			}
		},
		{
			path: '/delivery',
			name: 'Delivery',
			component: Delivery,
			meta: {
				title: '我的订单',
				keepAlive: !0
			}
		},
		{
			path: '/deliveryDetail',
			name: 'DeliveryDetail',
			component: DeliveryDetail,
			meta: {
				title: '我的订单详情'
			}
		},
		{
			path: '/factory',
			name: 'Factory',
			component: Factory,
			meta: {
				title: '生产查询',
				keepAlive: !0
			}
		},
		{
			path: '/factoryDetail',
			name: 'FactoryDetail',
			component: FactoryDetail,
			meta: {
				title: '工厂单详情'
			}
		},
		{
			path: '/orderStats',
			name: 'OrderStats',
			component: OrderStats,
			meta: {
				title: '订单统计',
				keepAlive: !0
			}
		},
		{
			path: '/productManage',
			name: 'ProductManage',
			component: ProductManage,
			meta: {
				title: '产品管理'
			}
		},
		{
			path: '/authManage',
			name: 'AuthManage',
			component: AuthManage,
			meta: {
				title: '权限管理'
			}
		},
		{
			path: '/memberManage',
			name: 'MemberManage',
			component: MemberManage,
			meta: {
				title: '会员管理'
			}
		},
		{
			path: '/settingsManage',
			name: 'SettingsManage',
			component: SettingsManage,
			meta: {
				title: '设置管理'
			}
		},
		{
			path: '/quoteManage',
			name: 'QuoteManage',
			component: QuoteManage,
			meta: {
				title: '报价单管理'
			}
		},
		{
			path: '/center',
			name: 'Center',
			component: Center,
			meta: {
				title: '用户信息'
			}
		},
		{
			path: '/passSet',
			name: 'PassSet',
			component: PassSet,
			meta: {
				title: '密码设置'
			}
		},
		{
			path: '/print',
			name: 'Print',
			component: Print,
			meta: {
				title: '报价单打印预览'
			}
		},
		{
			path: '/cuttingPrint',
			name: 'CuttingPrint',
			component: CuttingPrint,
			meta: {
				title: '切料优化打印预览'
			}
		},
		{
			path: '/collLogin',
			name: 'CollLogin',
			component: CollLogin,
			meta: {
				title: '协同订单登录'
			}
		},
		{
			path: '/collEdit',
			name: 'CollEdit',
			component: CollEdit,
			meta: {
				title: '协同订单详情'
			}
		},
	]
})

router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title
	}
	const publicPaths = ['/', '/register', '/collLogin', '/collEdit']
	if (!publicPaths.includes(to.path) && localStorage.getItem('userInfo')) {
		const ruleList = readRuleList()
		if (!canAccessFrontRoute(to.path, ruleList)) {
			const fallback = resolveDefaultFrontRoute(ruleList)
			next(fallback || '/')
			return
		}
	}
	next()
})

export default router
